interface ChatMessagesLoadingProps {
  amount: number;
}

export function ChatMessagesLoading({ amount }: ChatMessagesLoadingProps) {
  return (
    <>
      {Array.from({ length: amount }, (_, i) => (
        <li key={i} className="flex gap-3 px-3 py-2">
          <div className="size-8 shrink-0 rounded-full bg-accent animate-pulse" />
          <div className="flex-1 space-y-2 py-1">
            <div className="h-3 w-24 rounded bg-accent animate-pulse" />
            <div className="h-3 w-full rounded bg-secondary animate-pulse" />
          </div>
        </li>
      ))}
    </>
  );
}
